import { useEffect } from "react";
import { useHistory } from "react-router";

import {
  CartFulfillEventType,
  CartFulfillState,
  CartSelectors,
  getChildState,
  useCheckoutState,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import { B2BLoadingPopup, ErrorModal } from "@hopper-b2b/ui";
import { useUberBridge } from "@hopper-b2b/utilities";

import Error from "../../../../assets/client/error.svg";
import { PATH_FLIGHTS_SEARCH } from "../../../../utils/urlPaths";
import type { TEvent } from "../../events";
import { Selectors } from "../../selectors";
import type { PriceFreezeMachineContext } from "../../types";
import "./styles.scss";

export const CartFulfillComponent = (props) => {
  const { setHeader } = useUberBridge();
  const { t } = useI18nContext();
  const openCartFulfillModal = useSelector(
    CartSelectors.getOpenCartFulfillModal
  );
  const [state, send] = useCheckoutState<TEvent, PriceFreezeMachineContext>();
  const childState = getChildState(state.value);
  const history = useHistory();

  const getMessage = () => {
    switch (childState) {
      case CartFulfillState.schedule:
        return t("priceFreezePurchase.fulfillLoaderCopy");
      case CartFulfillState.polling:
        return t("priceFreezePurchase.fulfillLoaderCopy");
      default:
        return t("priceFreezePurchase.fulfillLoaderCopy");
    }
  };

  useEffect(() => {
    switch (childState) {
      case CartFulfillState.schedule || CartFulfillState.polling:
        setHeader({
          title: "",
        });
        break;
    }
  }, [childState, setHeader, t]);

  //Show error model on fulfillFailed state as well.
  const isOnFulfillFailedState = useSelector(Selectors.isOnFulfillFailedState);
  const openErrorModal =
    useSelector(CartSelectors.getOpenCartQuoteErrorModal) ||
    isOnFulfillFailedState;

  const clearError = () => send(CartFulfillEventType.CLEAR_CART_FULFILL_ERROR);
  const searchAgain = () => {
    clearError();
    history.push(PATH_FLIGHTS_SEARCH);
  };

  return (
    <>
      <B2BLoadingPopup
        {...props}
        open={openCartFulfillModal}
        fullScreen
        message={getMessage()}
        popupSize={"mobile"}
      />
      <ErrorModal
        open={openErrorModal}
        title={t("checkoutError.genericErrorTitle")}
        subtitle={t("checkoutError.genericErrorSubtitle")}
        primaryButtonText={t("checkoutError.searchAgain")}
        primaryOnClick={searchAgain}
        image={Error}
      />
    </>
  );
};
